import { useState, useEffect } from 'react';
import { sandhillsRequest, getBannerAd } from '@Components/Utilities/SandhillsUtility';
import Paging from '@Components/MuiWrappers/Paging';
import PhotoListing_SimplePhotoThumb from '@Components/Listings/PhotoListing_SimplePhotoThumb';
import AdditionalLinks from '@Components/Shared/AdditionalLinks';
import CategoryInformation from '@Components/Shared/CategoryInformation';
import DoubleClickAd from '@Components/Shared/DoubleClick/DoubleClickAd';
import { bannerAdPositions } from '@Components/Utilities/SandhillsConstants';

const PhotoListingsView = (props) => {

    useEffect(() => {
        window.addEventListener('popstate', handlePopState);

        return () => window.removeEventListener('popstate', handlePopState);
    }, []);

    const [modelData, setModelData] = useState(props);
    const [pushStateToWindowHistory, setPushStateToWindowHistory] = useState(true);

    const search = (data) => {
        sandhillsRequest({
            url: props.AjaxSearchUrl,
            method: 'post',
            data: {
                Criteria: data.Criteria,
                SearchText: data.SearchText,
                Page: data.Page
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then((response) => {
            if (response) {
                setModelData(response);
                if (pushStateToWindowHistory && window.history.pushState) {
                    try {
                        window.history.pushState(response, response.MetaTitle, response.UrlToShowInAddressBar);
                    } catch (error) {
                        setPushStateToWindowHistory(false);
                        window.removeEventListener('popstate', handlePopState);
                        window.history.pushState({}, response.MetaTitle, response.UrlToShowInAddressBar);
                        console.log('window history state disabled');
                    }
                } else {
                    window.history.pushState({}, response.MetaTitle, response.UrlToShowInAddressBar);
                }
            }
        });
    };

    const handlePopState = (e) => {
        if (pushStateToWindowHistory) {
            setModelData(e.state || props);
        }
    };

    const handlePageButtonClick = (page) => {
        if (page > 0 && page <= modelData.TotalPages) {
            window.scrollTo(0, 0);
            search({
                ...modelData,
                Page: page
            });
        }
    };

    const bottomBannerAd = getBannerAd(props.DoubleClickAdCollection?.AdUnits, bannerAdPositions.Bottom);
    const topBannerAd = getBannerAd(props.DoubleClickAdCollection?.AdUnits, bannerAdPositions.Top);

    return (
        <div>
            <CategoryInformation {...props.CategoryInformation} />
            {modelData.BreadCrumbs && modelData.BreadCrumbs.length > 0 &&
                <div className='breadcrumbs'>
                    <div className='container cf'>
                        <ul>
                        <li><a className='home' href={modelData.BreadCrumbs ? modelData.BreadCrumbs[0].Url : "/"}><i className='fas fa-home' aria-hidden='true'></i></a><i class="fas fa-angles-right"></i></li>
                        {modelData.BreadCrumbs.map((value, index) => (index > 0 ? <li key={value.Label + index}>{value.Url ? <a href={value.Url}>{value.Label}</a> : value.Label}<i class="fas fa-angles-right"></i></li> : null))}
                        </ul>
                    </div>
                </div>}
            <div className='main'>
                <div className='container cf'>
                    <h1 className='cf'>{modelData.PageHeader}</h1>
                </div>
                {topBannerAd && <DoubleClickAd
                    {...props.DoubleClickAdCollection}
                    position={bannerAdPositions.Top}
                    ad={topBannerAd}
                    contained
                />}                
                <div className='thumb-container'>
                    {modelData.Listings && modelData.Listings.map((value, index) =>
                        <>
                            <PhotoListing_SimplePhotoThumb {...value} key={value.DestinationUrl} />
                            {(index == props.DoubleClickBottomIndex - 1) && bottomBannerAd &&
                                <DoubleClickAd
                                    {...props.DoubleClickAdCollection}
                                    position={bannerAdPositions.Bottom}
                                    ad={bottomBannerAd}
                                    contained
                                    style={{ padding: 0 }}
                                />
                            }
                        </>
                    )}                    
                </div>
                <div className='clear'></div><br />
                {modelData.Listings && modelData.Listings.length > 0 ?
                    <Paging
                        currentPage={modelData.Page}
                        totalPages={modelData.TotalPages}
                        onChange={handlePageButtonClick}
                    />
                    :
                    <div className='no-results'>
                        No Listings Found
                    </div>}
                <div className='clear'></div>
                <br />
                <AdditionalLinks {...props.SearchByLinks} />
                <div className='aircraft-disclaimer'>{props.DisclaimerText}</div>
            </div>
        </div>
    );
};

export default PhotoListingsView;
global.PhotoListingsView = PhotoListingsView;